export const DD_RUM_APPLICATION_ID = import.meta.env.VITE_DD_RUM_APPLICATION_ID || '';
export const DD_RUM_CLIENT_TOKEN = import.meta.env.VITE_DD_RUM_CLIENT_TOKEN || '';
export const DD_ENV = import.meta.env.VITE_DD_ENV || 'development';